import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import Coins from "../../assets/icon/svgs/Coins.svg?react";
import File from "../../assets/icon/svgs/File.svg?react";
// import Frame from "../../assets/icon/svgs/Frame.svg?react";
import Help from "../../assets/icon/svgs/Help.svg?react";
import Home from "../../assets/icon/svgs/Home.svg?react";
import HouseManager from "../../assets/icon/svgs/HouseManager.svg?react";
import { useTranslation } from "react-i18next";
import { useUserContext } from "@/contexts/UserContextProvider";
import News from "../../assets/icon/svgs/News.svg?react";
// import Tool from "../../assets/icon/svgs/Tool.svg?react";
// import UserCheck from "../../assets/icon/svgs/UserCheck.svg?react";

const TabBar: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const { uncheckedTickets: unchekedTickets } = useUserContext();
  const { user } = useUserContext();

  const icons = [
    { icon: Home, title: t("sideBar.home_butt"), path: "/home" },
    user?.is_staff && {
      icon: HouseManager,
      title: t("sideBar.house_manager"),
      path: "/house-manager",
    },
    // { icon: UserCheck, title: t("sideBar.votings_butt"), path: "/votings" },
    { icon: File, title: t("sideBar.bills_butt"), path: "/bills" },
    // { icon: Coins, title: t("sideBar.funds_butt"), path: "/funds" },
    { icon: News, title: t("sideBar.news_butt"), path: "/news" },
    // { icon: Frame, title: t("sideBar.chat_butt"), path: "/chat" },
    // { icon: Tool, title: t("sideBar.service_butt"), path: "/service" },
    {
      icon: Help,
      title: t("sideBar.support_butt"),
      path: "/support",
      notification: unchekedTickets.length > 0,
    },
  ].filter(Boolean) as {
    icon: React.ComponentType<{ className?: string }>;
    title: string;
    path: string;
    notification?: boolean;
  }[];

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="flex flex-col gap-2">
      {icons.map((item) => (
        <div
          key={item.title}
          onClick={() => handleClick(item.path)}
          className={`flex flex-col gap-1 p-2 rounded-[12px] cursor-pointer relative ${
            location.pathname === item.path
              ? "bg-[#0027CB0D] text-blue-medium"
              : "bg-transparent text-[grey]"
          }`}
        >
          {<item.icon className="self-center w-6 h-6" />}
          <p className="text-[12px] font-medium text-center whitespace-pre-line">{item.title}</p>
          {item.notification && (
            <div className="absolute top-2 right-2 w-2 h-2 bg-red-common rounded-full"></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TabBar;
